export class PCSearchRequestModel {
    public constructor(
        search?: string,
        pageNumber?: number,
        pageSize?: number,
        paging?: boolean,
        orderBy?: string,
        direction?: string,
    ) {

        if (search) {
            this.search = search;
        } else {
            this.search = ``;
        }

        if (pageNumber) {
            this.pageNumber = pageNumber;
        } else {
            this.pageNumber = 1;
        }

        if (pageSize) {
            this.pageSize = pageSize;
        } else {
            this.pageSize = 10;
        }

        if (paging) {
            this.paging = paging;
        } else {
            this.paging = true;
        }

        if (orderBy) {
            this.orderBy = orderBy;
        } else {
            this.orderBy = ``;
        }

        if (direction) {
            this.direction = direction;
        } else {
            this.direction = `asd`;
        }


    }

    public pageNumber: number;
    public pageSize: number;
    public paging: boolean;
    public orderBy: string;
    public direction: string;
    public search: string;

}
